import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router';

import BrandLayout from '../components/BrandLayout';
import { getBrand } from '../reducers/index';

export default compose(
  withRouter,
  connect((state, ownProps) => {
    const activeRoute = ownProps.routes[ownProps.routes.length - 1];
    return {
      title: getBrand(state, ownProps.params.id || ownProps.params.brandId).name,
      brandId: ownProps.params.id || ownProps.params.brandId,
      routeName: activeRoute.name,
    };
  })
)(BrandLayout);
